/**
 * Coherence constant (Rule 12): the per-check affected-activity PREVIEW shows
 * the worst N (impact-sorted, §6) on BOTH the dashboard and the PDF. One source
 * of truth so the two surfaces never drift. Isomorphic — string/number only,
 * safe to import from browser-bundled dashboard components.
 * @module shared/activityPreview
 */

/** Rows shown in the per-check preview before "Show all" (dashboard) / the XLSX pointer (PDF). */
export const ACTIVITY_PREVIEW_ROWS = 12;

/**
 * Dashboard "Show all" expand cap. The browser never renders more than this many
 * per-check rows; beyond it the per-check XLSX is the complete-list sink. This is
 * also the cap the dashboard.json projection slices each per-check finding array
 * to (Stage 5.2) — one source of truth so the projection can never under-supply
 * what the table can show. ACTIVITY_PREVIEW_ROWS ≤ ACTIVITY_EXPAND_ROWS.
 */
export const ACTIVITY_EXPAND_ROWS = 50;

/**
 * Smart-show preview rule (10D-1.5/Sub-2 fix-up X5, lifted here in MEGAC-FIX F3
 * so the comparison tables share the standard-check inline-cap contract): when
 * truncation would hide exactly one row (total === cap + 1), show all rows
 * instead — a "Showing 12 of 13" badge is worse UX than the thirteenth row.
 *
 * @param {number} total
 * @param {number} [cap=ACTIVITY_PREVIEW_ROWS]
 * @returns {{ cap: number, truncated: boolean }}
 */
export function smartPreviewCap(total, cap = ACTIVITY_PREVIEW_ROWS) {
  if (total <= cap) return { cap: total, truncated: false };
  if (total === cap + 1) return { cap: total, truncated: false };
  return { cap, truncated: true };
}
